import { MIME_TYPES } from '@mantine/dropzone';
import { useEffect } from 'react';

export function onPaste(callback: any) {
  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {
      if (event.clipboardData?.files.length) {
        const pastedFiles = Array.from(event.clipboardData.files).filter((file) =>
          [MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.webp].includes(file.type as any)
        );
        if (pastedFiles.length > 0) {
          callback(pastedFiles);
        }
      }
    };

    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, []);
}
